<template>
  <v-container>
    <v-breadcrumbs :items="breadcrumbs" class="pl-0 py-1">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-row class="d-flex justify-end">
      <v-col class="justify-end col-auto searchFolder" flat>
        <p>利用区分:</p>
        <div>
          <v-chip
            small
            v-for="item in useTypeItems"
            :key="item.value"
            @click="selectItem(item)" 
            :color="filter.use_type == item.value ? item.color : 'default'"
          >
          {{item.text}}
          </v-chip>
        </div>

        <!-- <v-select
          hide-details="auto"
          v-model="filter.use_type"
          label="利用区分"
          outlined
          clearable
          dense
          :items="useTypeItems"
        ></v-select> -->
      </v-col>
      <v-col cols="3">
        <v-select
          hide-details="auto"
          v-model="filter.type"
          label="用途"
          outlined
          clearable
          dense
          :items="useTypes"
        ></v-select>
      </v-col>
      <v-col cols="2">
        <v-btn color="primary" height="40" block @click="searchFolder">
          <v-icon left>mdi-magnify-plus</v-icon>
          検索
        </v-btn>
      </v-col>
    </v-row>
    
    <!-- <v-row class="pb-2">
      <v-col cols="2">
        <v-text-field
          hide-details="auto"
          outlined
          dense
          clearable
          v-model="filter.name"
          label="フォルダ名"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-menu
          v-model="shootingDateMenu"
          :close-on-content-click="false"
          :nudge-bottom="5"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              hide-details="auto"
              outlined
              dense
              clearable
              v-model="filter.shooting_date"
              label="撮影日"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="jp-JP"
            v-model="filter.shooting_date"
            @input="shootingDateMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="2">
        <v-select
            hide-details="auto"
            v-model="filter.drone_type"
            label="撮影機体"
            outlined
            clearable
            dense
            :items="drone_type_items"
        ></v-select>
      </v-col>
      <v-col cols="2">
        <v-text-field
          hide-details="auto"
          outlined
          dense
          v-model="filter.shooting_height"
          label="高度(M)"
          clearable
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field
          hide-details="auto"
          outlined
          dense
          v-model.number="filter.gimbal_angle"
          label="ジンバル角度"
          v-mask="mask.angleMask"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-btn color="primary" height="40" block @click="getFolders">
          <v-icon left>mdi-magnify-plus</v-icon>検索
        </v-btn>
      </v-col>
    </v-row> -->
    <v-data-table
      disable-pagination
      hide-default-footer
      :headers="tableHeaders"
      :items="folders"
      :loading="loading"
      loading-text="ローディング..."
      no-data-text="該当データがありません。"
      class="elevation-1 mt-3"
      :header-props="{ sortIcon: null }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>
            <b>データ一覧</b>
            <span>（{{totalFolders}} 件）</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="mb-2" @click="showDataUploadDialog()">
            <v-icon left>mdi-cloud-upload</v-icon>データアップロード
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.thumbnail_path="{ item }">
        <v-row>
          <v-col  v-if="item.color_type.includes('color')" style="padding: 0px 5px 0px 0px; width:107px;">
            <v-img
              class="my-2 thumbnail-css"
              :style="item.thumbnail_color_path ? 'background: black' : null"
              max-width="107"
              :aspect-ratio="4 / 3"
              :src="item.thumbnail_color_path ? item.thumbnail_color_path : !item.detail_log_newest_color ? require('@/assets/images/no-image.png') : item.detail_log_newest_color.log_level==='ERROR'|| item.detail_log_newest_color.log_level==='FATAL' ? require('@/assets/images/no-image.png') : require('../assets/images/icon-loading.jpeg')"
              @click="viewFolderDroneDeploy(item)"
            ></v-img>
          </v-col>
          <v-col v-if="item.color_type.includes('thermal')" style="padding: 0px 5px 0px 0px; width:107px;">
            <v-img
              class="my-2"
              :style="item.thumbnail_thermal_path ? 'background: black' : null"
              max-width="107"
              :aspect-ratio="4 / 3"
              :src="item.thumbnail_thermal_path ? item.thumbnail_thermal_path : !item.detail_log_newest_thermal ? require('@/assets/images/no-image.png') : item.detail_log_newest_thermal.log_level==='ERROR'|| item.detail_log_newest_thermal.log_level==='FATAL' ? require('@/assets/images/no-image.png') : require('../assets/images/icon-loading.jpeg')"
              @click="viewFolderDroneDeploy(item)"
            ></v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="padding: 0px 5px 0px 0px; width:107px;">
            <v-img
              v-if="item.type=='video'"
              class="my-2"
              max-width="107"
              :aspect-ratio="4 / 3"
              src="../assets/images/video-icon.png"
            ></v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col style="padding: 0px 5px 0px 0px; width:107px;">
            <v-img
              v-if="item.type=='360image'"
              class="my-2"
              max-width="107"
              :aspect-ratio="4 / 3"
              src="../assets/images/image360.png"
            ></v-img>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.note="{ item }">
        {{ item.note }}
      </template>
      <template v-slot:item.property.shooting_date="{ item }">
        <span v-if="item.property.shooting_date">{{ item.property.shooting_date.split(' ')[0] }}</span>
        <v-spacer></v-spacer>
        <span v-if="item.property.shooting_date">{{ item.property.shooting_date.split(' ')[1] }}</span>
      </template>
      <template v-slot:item.app="{ item }">
        {{ checkSendAP(item) }}
      </template>
      <template v-slot:item.detail_log_level="{ item }">
        <div v-if="item.detail_log_level!==null">
          <v-icon v-if="item.detail_log_level.log_level==='INFO'" color="success">mdi-checkbox-marked-circle</v-icon>
          <v-icon v-if="item.detail_log_level.log_level==='WARNING'" color="#ffcc00">mdi-alert</v-icon>
          <v-icon v-if="item.detail_log_level.log_level==='ERROR'" color="warning">mdi-alert</v-icon>
          <v-icon v-if="item.detail_log_level.log_level==='FATAL'" color="error">mdi-close-octagon</v-icon>
        </div>
      </template>
      <template v-slot:item.use_type="{ item }">
        <v-chip
            v-if="item.use_type === '1construction'"
            color="purple lighten-1"
        >
          {{ getTypeItemText(item.use_type) }}
        </v-chip>
        <v-chip
            v-if="item.use_type === '2assessment'"
            color="green lighten-1"
        >
          {{ getTypeItemText(item.use_type) }}
        </v-chip>
        <v-chip
            v-if="item.use_type === '3maintenance'"
            color="orange lighten-1"
        >
          {{ getTypeItemText(item.use_type) }}
        </v-chip>
        <v-chip
            v-if="item.use_type === '4drone'"
            color="light-blue accent-4"
        >
          {{ getTypeItemText(item.use_type) }}
        </v-chip>
        
      </template>
      <template v-slot:item.type="{ item }">
        {{ getTypeText(item.type) }}
      </template>
      <template v-slot:item.created_user="{ item }">
        {{ item.created_user.split('@')[0] }}
      </template>
      
      <template
        v-slot:item.property.rtk="{ item }"
      >{{ item.property.rtk ? '有り' : (item.property.rtk === false ? '無し' : '')}}</template>
      <template
          v-slot:item.upload_status="{ item }"
      >
        <v-chip :class="getUploadStatusCssClass(item.upload_status)">{{ getUploadStatus(item.upload_status) }}</v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="text-right">
          <v-btn color="primary" text @click="viewFolderDroneDeploy(item)" v-if="item.type == 'map'">ビュー</v-btn>
          <v-btn color="primary" text @click="viewFolder(item)" v-if="item.type == 'map' || item.type == 'video'">詳細</v-btn>
          <v-btn color="primary" text @click="rerunODM(item)" v-if="item.type == 'map' && (item.app == 'opendronemap' || item.app == 'opendronemap_lightning')">再構築</v-btn>
          <span v-if="item.type == 'map'">
            <v-btn color="primary" text @click="reupload(item)" v-show="item.upload_status === 'UPLOAD_FAILED'">再アップロード</v-btn>
            <v-btn color="primary" text @click="reuploadDD(item)" v-show="item.upload_status === 'DD_UPLOAD_FAILED'">DroneDeployに再送信</v-btn>
            <v-btn color="primary" text @click="reuploadAP(item)" v-show="item.upload_status === 'AP_UPLOAD_FAILED'">AI MODEL Aに再送信</v-btn>
          </span>
          <!-- 管理者またはフォルダ作成者しか削除できない -->
          <v-btn
            v-if="sharedState.role === 'admin' || sharedState.email === item.created_user"
            color="error"
            text
            @click="confirmDeleteFolder(item)"
          >削除</v-btn>
        </div>
      </template>
    </v-data-table>

    <data-upload-dialog v-model="uploadDataDialog" :plantId="$route.params.plantId" @uploaded="getFolders()"></data-upload-dialog>
    <odm-rerun-dialgo v-model="odmRerun" v-if="odmRerun" :folderId="selectedFolder.id"></odm-rerun-dialgo>
  </v-container>
</template>

<script>
import { store } from "../store";
import * as commonUtil from "../utils/common";
import DataUploadDialog from "./dialog/DataUploadDialog";
import ODMRerunDialog from "@/components/dialog/ODMRerunDialog";

export default {
  name: "Folder",

  components:{
    'data-upload-dialog': DataUploadDialog,
    'odm-rerun-dialgo': ODMRerunDialog
  },

  data() {
    return {
      sharedState: store.state,
      breadcrumbs: [
        {
          text: "発電所一覧",
          disabled: false,
          exact: true,
          to: "/plant",
        },
        {
          text: "",
        },
      ],
      //search by "利用区分"
      useTypeItems: [
        // { text: "全て", value: "all"},
        { text: "工事", value: "1construction", color: "purple lighten-1" },
        { text: "査定", value: "2assessment", color: "green lighten-1" },
        { text: "メンテ", value: "3maintenance", color: "orange lighten-1" },
        { text: "ドローン", value: "4drone", color: "light-blue accent-4" },
      ],
      //search by "用途"
      useTypes: [
        { text: "全て", value: "all" },
        { text: "マップ・モデル", value: " map" },
        { text: "図面", value: "diagram" },
        { text: " 360画像", value: "360image" },
        { text: "動画", value: "video" },
      ],
      filter: {
        plant_id: this.$route.params.plantId,
        // block_id: this.$route.params.blockId,
        // shooting_date: null,
      //   drone_type: null,
      //   shooting_height: null,
      //   gimbal_angle: null,
        type: null,
        use_type: null,
        
      },
      shootingDateMenu: false,
      dialogShootingDateMenu: false,
      createFolderDialog: false,
      uploadDataDialog: false,
      formValid: true,
      inputCreateForder: {
        plant_id: this.$route.params.plantId,
        name: null,
        property: {
          shooting_date: null,
          drone_type: null,
          shooting_height: null,
          gimbal_angle: null,
          gcp: null,
          weather: null,
          solar_radiation: null,
        },
      },
      gcps: [
        { text: "有り", value: true },
        { text: "無し", value: false },
      ],
      weathers: [
        { text: "晴れ", value: "sunny" },
        { text: "曇り", value: "cloudy" },
      ],
      loading: true,
      tableHeaders: [
        {
          text: "サムネイル",
          sortable: false,
          value: "thumbnail_path",
          width: "230px",
        },
        {
          text: "備考",
          sortable: false,
          value: "note",
          width: "15%",
        },
        {
          text: "撮影日付",
          sortable: true,
          value: "property.shooting_date",
          width: "10%",
        },
        {
          text: "MODEL A",
          sortable: true,
          value: "app",
        },
        {
          text: "状況",
          sortable: true,
          value: "detail_log_level",
        },
        {
          text: "機体",
          sortable: true,
          value: "property.drone_type",
        },
        {
          text: "作成者",
          sortable: true,
          value: "created_user",
        },
        {
          text: "利用区分",
          sortable: true,
          value: "use_type",
        },
        // {
        //   text: "高度(M)",
        //   sortable: true,
        //   value: "property.shooting_height",
        // },
        // {
        //   text: "ジンバル角度",
        //   sortable: true,
        //   value: "property.gimbal_angle",
        // },
        {
          text: "RTK",
          sortable: true,
          value: "property.rtk",
        },
        // {
        //   text: "アップロード",
        //   sortable: true,
        //   value: "upload_status",
        //   width: "100px",
        // },
        {
          text: "アクション",
          sortable: false,
          value: "actions",
          align: "center",
          width: "10%",
        },
      ],
      plant: {},
      block: {},
      totalFolders: 0,
      folders: [],
      drone_type_items: ['M200', 'M300', 'MAVIC', 'M2EA', 'P4R', 'X4S', 'I1'],
      reuploadDialog: false,
      reuploadFolder: null,
      odmRerun: false,
      selectedFolder: {
        id: null
      }
    };
  },

  methods: {
    resetData() {
      this.loading = true;
      this.totalFolders = 0;
      this.folders = [];
    },
    getFolders() {
      this.resetData();
      this.axios.post("/api/folders", this.filter).then((response) => {
        this.loading = false;
        this.folders = response.data;
        this.totalFolders = this.folders.length;
      });
    },
    getFatherData() {
      this.axios.get("/api/main-plant/" + this.$route.params.plantId).then((response) => {
        this.plant = response.data;
        this.breadcrumbs[1].text = this.plant.plant_name;
      });
    },
    getPlant(plantId) {
      this.axios
        .get('/api/main-plant/' + plantId)
        .then((response)=>{
          this.plant = response.data;
          this.breadcrumbs[1].text = this.plant.plant_name;
          this.breadcrumbs[1].to = "/plant/" + plantId + "/block";
        });
    },
    getTypeText(type) {
      const uploadTypes = [
        { text: "マップ・モデル", value: "map" },
        { text: "図面", value: "diagram"},
        { text: "360°画像", value: "360image" },
        { text: "動画", value: "video"},
      ];
      return uploadTypes.find(x => x.value == type).text;
    },
    getTypeItemText(use_type) {
      return commonUtil.getUseTypeString(use_type);
    },
    viewFolder(folder) {
      if (folder.type === 'map'){
        this.$router.push("/folder/" + folder.id);
      }
      else{
        this.$router.push('/video/' + folder.id);
      }
    },
    confirmDeleteFolder(folder) {
      const s = folder.property.shooting_date ? '「' + folder.property.shooting_date + '」' : '';
      const confirmDialog = {
        title: '削除確認',
        content: s + "データを削除します。よろしいですか。",
        onAgree: () => this.deleteFolder(folder),
        onDisagree: null,
      };
      store.showConfirmDialog(confirmDialog);
    },
    deleteFolder(folder) {
      this.axios
        .delete("/api/folder/" + folder.id)
        .then((response) => {
          if (response.status === 204) {
            const s = folder.property.shooting_date ? '「' + folder.property.shooting_date + '」' : '';
            store.showSuccessDialog(s + "データ削除が完了しました。");
            this.getFolders();
          }
        })
        .catch(() => {
          store.showErrorDialog('エラーが発生しました。再度試してください。');
        });
    },
    closeDialog() {
      this.createFolderDialog = false;
      this.$refs.createFolderForm.reset();
    },
    viewFolderDroneDeploy(folder) {
      this.axios.get("/api/folder/layers-info/" + folder.id)
          .then(() => {
            this.$router.push('/map/' + folder.id);
          }).catch(() => {
            store.showErrorDialog('マップデータはありません。');
          });
    },
    showDataUploadDialog() {
      this.uploadDataDialog = true;
    },
    searchFolder() {
      this.getFolders();
    },
    selectItem(item) {
      if(this.filter.use_type == item.value){
        this.filter.use_type = '';
      }else{
        this.filter.use_type = item.value;
      } 
    },
    reupload(folder){
      this.$router.push({
        name: 'FolderReupload',
        params: {
          folderId: folder.id,
          selectedFolder: folder
        }
      });
    },
    reuploadDD(folder){
      this.axios
          .post('/api/folder/reupload/dronedeploy/' + folder.id)
          .then(() => {
            store.showSuccessDialog('DroneDeployに再送信しました。マップ表示できるまで少々お待ちください。');
          })
          .catch(() => {
            store.showErrorDialog('DroneDeployに再送信失敗しました。再度試してください。');
          })
    },
    reuploadAP(folder){
      this.axios
          .post('/api/folder/reupload/airprobe/' + folder.id)
          .then(() => {
            store.showSuccessDialog('AI MODEL Aに再送信しました。マップ表示できるまで少々お待ちください。');
          })
          .catch(() => {
            store.showErrorDialog('AI MODEL Aに再送信失敗しました。再度試してください。');
          })
    },
    getUploadStatus(status){
      switch (status) {
        case 'UPLOAD_SUCCESS':{
          return '成功';
        }
        case 'DD_UPLOAD_FAILED':
        case 'UPLOAD_FAILED':
        case 'AP_UPLOAD_FAILED':{
          return '失敗';
        }
        case 'UPLOADING':{
          return '処理中';
        }
        default: {
          return '';
        }
      }
    },
    getUploadStatusCssClass(status){
      switch (status) {
        case 'UPLOAD_SUCCESS':{
          return 'success';
        }
        case 'DD_UPLOAD_FAILED':
        case 'UPLOAD_FAILED':
        case 'AP_UPLOAD_FAILED':{
          return 'error';
        }
        case 'UPLOADING':{
          return 'secondary';
        }
        default: {
          return '';
        }
      }
    },    
    checkSendAP(item) {
      if (item.type == 'map' && item.app == 'airprobe') {
          return '送信';
      }
    },
    rerunODM(item){
      this.selectedFolder = item;
      this.odmRerun = true;
    }
  },
  created() {
    this.getFatherData();
    this.filter.use_type = store.state.plant_search_filter.useType;
    this.filter.type = store.state.plant_search_filter.type;
    this.getFolders();
  }
};
</script>

<style lang="scss">
td > .v-image:hover {
  cursor: pointer;
}
.searchFolder {
  padding: 0px;
  margin-right: 20px;;
}
.searchFolder p{
  margin-bottom: 0px !important;
  font-size: 14px;

}
.searchFolder .v-chip{
  margin: 5px;
}
td {
  padding: 0 13px !important;
}
</style>
